import React from 'react';
import { v360organizationDataTypeProps } from 'custom-type';

export const V360EntityRegistrationStatus: React.FC<v360organizationDataTypeProps> = (props) => {
  return (
    <div className="main-content-sec padd-content-top full-width">
      <div className="confirmed-info-container">
        {
          props.organization_logo &&
          <div className="d-flex justify-content-center align-items-center mt-3 mb-4">
            <img
              alt="Logo"
              height="93"
              src={props.organization_logo}
              style={{ display: 'inline-block', verticalAlign: 'middle' }}
              width="221"
            />
          </div>
        }
        <strong className="d-block pb-1 text-center" style={{ fontSize: '22px', color: `${props.responseStatus ? 'green' : 'red'}` }}>
          <span className={props.responseStatus ? 'bi bi-check-lg fs-20' : 'bi bi-x-lg fs-20'}></span>
          <span>{props.responseMessage}</span>
        </strong>
        <br />
        <p className="text-center" style={{ color: '#0097d0', fontSize: '25px', marginBottom: '10px' }}>Thank You</p>
        <p className="text-center" style={{ fontSize: '18px', margin: '0px' }}>Team {props.organization_name}</p>
      </div>
    </div>
  );
};

export default V360EntityRegistrationStatus;
